import React, { useState } from 'react';
import '../styles/Gallery.css';
import ContactPreview from './Home/ContactPreview';

const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const galleryImages = [
    // Hotel Exterior
    {
      id: 1,
      category: 'exterior',
      image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      title: 'Hotel Exterior',
      description: 'Beautiful facade of AA GRAND HOTEL'
    },
    {
      id: 2,
      category: 'exterior',
      image: 'https://images.unsplash.com/photo-1584132967334-10e028bd69f7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      title: 'Hotel Entrance',
      description: 'Grand entrance with warm lighting'
    },
    // Rooms
    {
      id: 3,
      category: 'rooms',
      image: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      title: 'Standard Room',
      description: 'Comfortable and cozy standard room'
    },
    {
      id: 4,
      category: 'rooms',
      image: 'https://images.unsplash.com/photo-1618773928121-c32242e63f39?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      title: 'Deluxe Room',
      description: 'Spacious deluxe room with premium amenities'
    },
    {
      id: 5,
      category: 'rooms',
      image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      title: 'Suite Room',
      description: 'Luxurious suite with separate living area'
    },
    // Dining
    {
      id: 6,
      category: 'dining',
      image: 'https://images.unsplash.com/photo-1590490360182-c33d57733427?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      title: 'Restaurant',
      description: 'Elegant dining space with delicious cuisine'
    },
    {
      id: 7,
      category: 'dining',
      image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      title: 'Dining Area',
      description: 'Perfect ambiance for romantic dinners'
    },
    // Amenities
    {
      id: 8,
      category: 'amenities',
      image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      title: 'Lobby',
      description: 'Welcoming lobby with modern design'
    },
    {
      id: 9,
      category: 'amenities',
      image: 'https://images.unsplash.com/photo-1561501900-3701fa6a0864?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      title: 'Corridor',
      description: 'Elegant corridor with artistic touch'
    }
  ];

  const categories = [
    { id: 'all', label: 'All Photos' },
    { id: 'exterior', label: 'Exterior' },
    { id: 'rooms', label: 'Rooms' },
    { id: 'dining', label: 'Dining' },
    { id: 'amenities', label: 'Amenities' }
  ];

  const filteredImages = activeCategory === 'all'
    ? galleryImages
    : galleryImages.filter(img => img.category === activeCategory);

  const [selectedImage, setSelectedImage] = useState(null);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="gllery-page-wrapper">
      {/* Hero Banner */}
      <div className="gllery-hero-section">
        <div className="gllery-hero-overlay">
          <div className="gllery-hero-content">
            <span className="gllery-hero-badge">✦ Our Gallery</span>
            <h1 className="gllery-hero-title">
              Photo <span className="gllery-hero-highlight">Gallery</span>
            </h1>
            <p className="gllery-hero-subtitle">
              Explore the beauty and elegance of AA GRAND HOTEL
            </p>
          </div>
        </div>
      </div>

      {/* Gallery Content */}
      <div className="gllery-content-section">
        <div className="gllery-container">
          {/* Category Filters */}
          <div className="gllery-filter-bar">
            <span className="gllery-filter-label">Categories:</span>
            <div className="gllery-filter-tags">
              {categories.map((category) => (
                <button
                  key={category.id}
                  className={`gllery-filter-tag ${activeCategory === category.id ? 'gllery-active' : ''}`}
                  onClick={() => setActiveCategory(category.id)}
                >
                  {category.label}
                </button>
              ))}
            </div>
            <span className="gllery-image-count">{filteredImages.length} photos</span>
          </div>

          {/* Gallery Grid */}
          <div className="gllery-grid">
            {filteredImages.map((image) => (
              <div
                key={image.id}
                className="gllery-grid-item"
                onClick={() => openLightbox(image)}
              >
                <img src={image.image} alt={image.title} />
                <div className="gllery-grid-overlay">
                  <div className="gllery-grid-info">
                    <h4>{image.title}</h4>
                    <p>{image.description}</p>
                    <span className="gllery-view-icon">🔍</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* No Images Message */}
          {filteredImages.length === 0 && (
            <div className="gllery-no-images">
              <span className="gllery-no-icon">📷</span>
              <h3>No photos found</h3>
              <p>Try selecting a different category</p>
            </div>
          )}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="gllery-lightbox" onClick={closeLightbox}>
          <button className="gllery-lightbox-close" onClick={closeLightbox}>✕</button>
          <div className="gllery-lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage.image} alt={selectedImage.title} />
            <div className="gllery-lightbox-info">
              <h3>{selectedImage.title}</h3>
              <p>{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
      <ContactPreview/>
    </div>
  );
};

export default Gallery;